import UnicusAccountStore from "unicus-ui/module/account/store";

const AccountStore = UnicusAccountStore();

export default AccountStore;
